var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":"","pa-1":""}},[(this.isComponent('scb-dash'))?_c('components'):(this.isComponent('scb-channel'))?_c('components'):(this.isComponent('zone-monitoring'))?_c('components'):_c('no-device',{attrs:{"message":_vm.subscriptionMessage}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }